<template>
  <section id="contact" class="py-32 bg-gradient-to-b from-amber-50 to-white relative overflow-hidden">
    <div class="absolute bottom-0 left-0 w-96 h-96 bg-amber-100 rounded-full blur-3xl"></div>
    <div class="absolute top-0 right-0 w-96 h-96 bg-orange-100 rounded-full blur-3xl"></div>
    
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
      <div class="grid lg:grid-cols-2 gap-20">
        <div>
          <div class="inline-flex items-center px-5 py-2.5 bg-amber-100 rounded-full mb-8">
            <Phone :size="20" class="mr-2 text-amber-600" />
            <span class="text-sm font-semibold text-amber-700">联系我们</span>
          </div>
          
          <h2 class="text-4xl sm:text-5xl font-bold font-display text-dark mb-6">
            欢迎
            <span class="text-amber-600">咨询洽谈</span>
          </h2>
          
          <p class="text-lg text-gray-600 mb-12">
            无论您是想了解产品详情、获取报价还是洽谈合作，我们都很乐意帮助您。请填写下方表单或通过其他方式联系我们。
          </p>
          
          <div class="space-y-8">
            <div class="group flex items-start gap-6">
              <div class="w-14 h-14 bg-amber-100 rounded-2xl flex items-center justify-center group-hover:bg-amber-500 transition-all duration-300">
                <MapPin :size="28" class="text-amber-600 group-hover:text-white transition-colors" />
              </div>
              <div>
                <h4 class="text-lg font-semibold text-dark mb-2">公司地址</h4>
                <p class="text-gray-600">宁夏回族自治区西吉县吉强镇闽宁大道西吉工业园区食品园8号</p>
              </div>
            </div>
            
            <div class="group flex items-start gap-6">
              <div class="w-14 h-14 bg-amber-100 rounded-2xl flex items-center justify-center group-hover:bg-amber-500 transition-all duration-300">
                <Phone :size="28" class="text-amber-600 group-hover:text-white transition-colors" />
              </div>
              <div>
                <h4 class="text-lg font-semibold text-dark mb-2">联系电话</h4>
                <p class="text-gray-600">13693620799</p>
              </div>
            </div>
            
            <div class="group flex items-start gap-6">
              <div class="w-14 h-14 bg-amber-100 rounded-2xl flex items-center justify-center group-hover:bg-amber-500 transition-all duration-300">
                <Mail :size="28" class="text-amber-600 group-hover:text-white transition-colors" />
              </div>
              <div>
                <h4 class="text-lg font-semibold text-dark mb-2">电子邮箱</h4>
                <p class="text-gray-600">sales@ximingeco.com</p>
              </div>
            </div>
            
            <div class="group flex items-start gap-6">
              <div class="w-14 h-14 bg-amber-100 rounded-2xl flex items-center justify-center group-hover:bg-amber-500 transition-all duration-300">
                <Clock :size="28" class="text-amber-600 group-hover:text-white transition-colors" />
              </div>
              <div>
                <h4 class="text-lg font-semibold text-dark mb-2">工作时间</h4>
                <p class="text-gray-600">周一至周六 8:00 - 18:00</p>
              </div>
            </div>
          </div>
        </div>
        
        <div class="relative">
          <div class="absolute inset-0 bg-gradient-to-br from-amber-100 to-orange-100 rounded-3xl"></div>
          <div class="relative bg-white rounded-3xl p-10 shadow-xl">
            <h3 class="text-2xl font-bold font-display text-dark mb-8">获取报价</h3>
            
            <form @submit.prevent="handleSubmit" class="space-y-6">
              <div class="grid md:grid-cols-2 gap-6">
                <div>
                  <label class="block text-sm font-semibold text-gray-700 mb-3">姓名</label>
                  <input v-model="form.name" type="text" placeholder="请输入您的姓名"
                         class="w-full px-5 py-4 bg-amber-50 rounded-xl border-2 border-transparent focus:border-amber-500 focus:bg-white outline-none transition-all duration-300" />
                </div>
                <div>
                  <label class="block text-sm font-semibold text-gray-700 mb-3">电话</label>
                  <input v-model="form.phone" type="tel" placeholder="请输入您的电话"
                         class="w-full px-5 py-4 bg-amber-50 rounded-xl border-2 border-transparent focus:border-amber-500 focus:bg-white outline-none transition-all duration-300" />
                </div>
              </div>
              
              <div>
                <label class="block text-sm font-semibold text-gray-700 mb-3">公司名称</label>
                <input v-model="form.company" type="text" placeholder="请输入公司名称"
                       class="w-full px-5 py-4 bg-amber-50 rounded-xl border-2 border-transparent focus:border-amber-500 focus:bg-white outline-none transition-all duration-300" />
              </div>
              
              <div>
                <label class="block text-sm font-semibold text-gray-700 mb-3">感兴趣的产品</label>
                <select v-model="form.product"
                        class="w-full px-5 py-4 bg-amber-50 rounded-xl border-2 border-transparent focus:border-amber-500 focus:bg-white outline-none transition-all duration-300">
                  <option value="">请选择产品</option>
                  <option value="精炼牛油">精炼牛油</option>
                  <option value="浓香鸡油">浓香鸡油</option>
                  <option value="浓香牛油">浓香牛油</option>
                  <option value="原味鸡油">原味鸡油</option>
                  <option value="原味牛油">原味牛油</option>
                  <option value="牛油软脂">牛油软脂</option>
                  <option value="其他">其他</option>
                </select>
              </div>
              
              <div>
                <label class="block text-sm font-semibold text-gray-700 mb-3">需求量</label>
                <input v-model="form.quantity" type="text" placeholder="请输入预计需求量（kg）"
                       class="w-full px-5 py-4 bg-amber-50 rounded-xl border-2 border-transparent focus:border-amber-500 focus:bg-white outline-none transition-all duration-300" />
              </div>
              
              <div>
                <label class="block text-sm font-semibold text-gray-700 mb-3">留言</label>
                <textarea v-model="form.message" rows="4" placeholder="请输入您的需求或问题"
                          class="w-full px-5 py-4 bg-amber-50 rounded-xl border-2 border-transparent focus:border-amber-500 focus:bg-white outline-none transition-all duration-300 resize-none"></textarea>
              </div>
              
              <button type="submit" class="w-full px-8 py-4 bg-gradient-to-r from-amber-500 to-orange-500 text-white font-semibold rounded-xl hover:opacity-90 transition-all duration-300 shadow-lg shadow-amber-500/30">
                提交询价
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { ref } from 'vue'
import { Phone, MapPin, Mail, Clock } from 'lucide-vue-next'

const form = ref({
  name: '',
  phone: '',
  company: '',
  product: '',
  quantity: '',
  message: ''
})

const handleSubmit = () => {
  alert('询价信息已提交！我们会尽快与您联系。')
  form.value = { name: '', phone: '', company: '', product: '', quantity: '', message: '' }
}
</script>
